import React from 'react';

import { MoneyCell } from '@/cip/widgets/Table/MoneyCell';
import { NumberCell } from '@/cip/widgets/Table/NumberCell';

export const pnlColorClass = (value: unknown): string => {
    const n = typeof value === 'number' ? value : Number(value);
    if (!Number.isFinite(n) || n === 0) return '';
    return n > 0 ? 'text-green-600' : 'text-red-600';
};

type PnlCellProps = { value: number | undefined };

export const PnlMoneyCell: React.FC<PnlCellProps> = ({ value }) => (
    <div className={pnlColorClass(value)}>
        <MoneyCell value={value} />
    </div>
);

export const PnlPercentCell: React.FC<PnlCellProps> = ({ value }) => (
    <div className={pnlColorClass(value)}>
        <NumberCell value={value} style="percent" />
    </div>
);

export const isPnlMoneyColumn = (id: string | undefined): boolean => id === 'pnlUnrealized' || id === 'pnlRealized';

export const isPnlPercentColumn = (id: string | undefined): boolean =>
    id === 'returnUnrealized' || id === 'returnRealized';
